import React from 'react'
import styles from './DetailLine.module.scss'

type Props = {
    title: string
    line1: string
    line2?: string
    line3?: string
}

const DetailLine = (props: Props) => {
    return (
        <div className={styles.detailLine}>

            <h6 className={styles.detailLine__title}>{props.title}</h6>
            <h5>{props.line1}</h5>
            {props.line2 && <h5>{props.line2}</h5>}
            {props.line3 && <h5>{props.line3}</h5>}
        </div>
    )
}

export default DetailLine